import { Lookup } from './lookup.interface';
import { GOV_NAME_LONG, GOV_NAME_SHORT } from '@govalta-emu/alss-common';
import { MINISTRY_NAME_LONG, MINISTRY_NAME_SHORT } from './ministry-name';

export interface MinistryLookup extends Lookup {
  sector?: string;
  orgShortName?: string;
  orgFullName?: string;
}
export type Ministry = 'scss';
//displayValue: represents ministry full name (Assisted Living and Social Services)
//code: represents the ministry acronym (ALSS)
export const MinistryList: Record<Ministry, MinistryLookup> = {
  scss: {
    code: MINISTRY_NAME_SHORT,
    displayValue: MINISTRY_NAME_LONG,
    orgShortName: GOV_NAME_SHORT,
    orgFullName: GOV_NAME_LONG,
  },
};
